import { RemoteCancelRecurringPushNotification } from 'data/usecases';
import { CancelRecurringPushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCancelRecurringPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeCancelRecurringPushNotification =
  (): CancelRecurringPushNotificationUseCaseInterface =>
    new RemoteCancelRecurringPushNotification(
      makeApiUrlCancelRecurringPushNotification(),
      makeAxiosHttpClient(),
    );
